import { useTranslation } from "@opendash/i18n";
import { Button, Flex, Form, Typography } from "antd";
import React from "react";
import ValueOverwritesListItem from "./ValueOverwritesListItem";

export default () => {
  const t = useTranslation();

  return (
    <div style={{ marginBottom: 24 }}>
      <Typography.Text style={{ paddingBottom: 8, display: "block" }}>
        {t("openware:parse.form.overwrites.title")}
      </Typography.Text>
      <Form.List name="valueOverwrites">
        {(innerFields, overwrite, meta) => {
          return (
            <Flex gap={16} vertical justify="center">
              {innerFields.map((field, index) => (
                <ValueOverwritesListItem
                  key={field.key}
                  onDelete={() => overwrite.remove(field.name)}
                  index={index}
                />
              ))}
              <Button onClick={() => overwrite.add()} type="dashed">
                {t("openware:parse.form.overwrite.add.label")}
              </Button>
            </Flex>
          );
        }}
      </Form.List>
    </div>
  );
};
